// extracted by mini-css-extract-plugin
export default {"component":"ScoreTable_component__jn21p","outer":"ScoreTable_outer__WcZnQ","cardsContainer":"ScoreTable_cardsContainer__Y0LaD","dark":"ScoreTable_dark__z33YO"};